<section aria-labelledby="rpt-headline" aria-live="polite">
  @if (loading && !kpis().length) {
    <div class="animate-pulse space-y-3" aria-hidden="true">
      <div class="h-4 w-48 rounded bg-gray-200 dark:bg-gray-800"></div>
      <div class="h-9 w-full max-w-xl rounded bg-gray-200 dark:bg-gray-800"></div>
      <div class="h-4 w-full max-w-2xl rounded bg-gray-200 dark:bg-gray-800"></div>
      <div class="mt-6 h-32 rounded-2xl bg-gray-200 dark:bg-gray-800"></div>
    </div>
  } @else if (kpis().length) {
    <div class="transition-opacity" [class.opacity-60]="loading">
      <p class="text-sm text-gray-500 dark:text-gray-400">Del {{ rangeLabel }}</p>
      <h2 id="rpt-headline" class="mt-1 max-w-4xl font-display text-2xl font-semibold leading-tight tracking-tight text-gray-900 tabular-nums text-balance sm:text-[1.75rem] dark:text-white">
        {{ headline() }}
      </h2>
      @if (insights().length) {
        <!-- Lecturas en una línea cada una; el detalle vive en el panel -->
        <div class="mt-4 flex flex-wrap items-center gap-2">
          @for (item of insights(); track item.kind) {
            <button type="button" (click)="openSummary.emit()"
              class="inline-flex max-w-full items-center gap-2 rounded-full border border-gray-200 bg-white py-1.5 pl-2.5 pr-3.5 text-sm text-gray-700 transition-colors hover:border-gray-300 hover:bg-gray-50 focus-visible:outline-2 focus-visible:outline-brand-500 dark:border-gray-800 dark:bg-gray-dark dark:text-gray-300 dark:hover:border-gray-700">
              <span class="h-2 w-2 shrink-0 rounded-full"
                [class]="item.tone === 'up' ? 'bg-success-500' : item.tone === 'down' ? 'bg-error-500' : 'bg-gray-400 dark:bg-gray-500'"
                aria-hidden="true"></span>
              <span class="truncate tabular-nums">{{ item.title }}</span>
            </button>
          }
          <button type="button" (click)="openSummary.emit()"
            class="inline-flex items-center gap-1 rounded-full px-2 py-1.5 text-sm font-medium text-brand-600 hover:underline focus-visible:outline-2 focus-visible:outline-brand-500 dark:text-brand-400">
            Ver resumen completo
          </button>
        </div>
      }

      <!-- Indicadores: una sola franja, cada celda con su comparación explícita -->
      <dl class="mt-6 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-gray-200 bg-gray-200 sm:grid-cols-2 lg:grid-cols-4 dark:border-gray-800 dark:bg-gray-800">
        @for (k of kpis(); track k.label) {
          <div class="bg-white p-5 dark:bg-gray-900">
            <dt class="text-sm font-medium text-gray-500 dark:text-gray-400">{{ k.label }}</dt>
            <dd class="mt-1.5 truncate font-display text-[1.75rem] font-semibold leading-none tracking-tight text-gray-900 tabular-nums dark:text-white" [title]="k.value">{{ k.value }}</dd>
            <dd class="mt-3 flex flex-wrap items-center gap-x-2 gap-y-1 text-sm">
              @if (k.trend === null) {
                <span class="text-gray-500 dark:text-gray-400">Sin datos del período anterior</span>
              } @else {
                <span class="inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 font-medium tabular-nums"
                  [class]="k.trend > 0
                    ? 'bg-success-50 text-success-700 dark:bg-success-500/15 dark:text-success-400'
                    : k.trend < 0
                      ? 'bg-error-50 text-error-700 dark:bg-error-500/15 dark:text-error-400'
                      : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300'">
                  @if (k.trend > 0) {
                    <svg class="h-3.5 w-3.5" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M8 3.5 13 9H3z" /></svg>
                    <span class="sr-only">Subió</span>
                  } @else if (k.trend < 0) {
                    <svg class="h-3.5 w-3.5" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M8 12.5 3 7h10z" /></svg>
                    <span class="sr-only">Bajó</span>
                  }
                  {{ formatTrend(k.trend) }}
                </span>
                <span class="text-gray-500 dark:text-gray-400 tabular-nums">antes {{ k.previous }}</span>
              }
            </dd>
            <dd class="mt-1 text-sm text-gray-500 dark:text-gray-400">{{ k.caption }}</dd>
          </div>
        }
      </dl>
      @if (previousRangeLabel()) {
        <p class="mt-2 text-xs text-gray-500 dark:text-gray-400">La comparación es contra el período anterior de igual duración: {{ previousRangeLabel() }}.</p>
      }
    </div>
  }
</section>
